import {Component, Input, Output, EventEmitter, OnInit, HostListener} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {EMAIL_PATTERN, IP_PATTERN, NUMBER_PATTERN, PASSWORD_PATTERN} from 'app/common';
import {AppToastrService, UsersService} from '../../../services';

@Component({
  selector: 'app-edit-password-popup',
  templateUrl: './edit-password.html'
})
export class EditPasswordComponent implements OnInit {
  @Input() types: any[];
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  oldPasswordCtrl: FormControl;
  newPasswordCtrl: FormControl;
  approvePasswordCtrl: FormControl;
  form: FormGroup;
  submitPressed: boolean;
  submitting: boolean;
  errorMessage: string;
  oldPassword: string;

  @HostListener('window:keyup', ['$event']) onKey(event) {
    if (event.keyCode === 27) {
      this.onClose();
    }
  }


  constructor(private toast: AppToastrService,
              private usersService: UsersService,
              private fb: FormBuilder) {
  }

  ngOnInit() {
    this.prepareForm();
  }

  private prepareForm() {
    this.oldPasswordCtrl = this.fb.control('', [Validators.required]);
    this.newPasswordCtrl = this.fb.control('', [Validators.required, Validators.pattern(PASSWORD_PATTERN)]);
    this.approvePasswordCtrl = this.fb.control('', [Validators.required, Validators.pattern(PASSWORD_PATTERN)]);
    this.form = this.fb.group({
      oldPassword: this.oldPasswordCtrl,
      newPassword: this.newPasswordCtrl,
      approvePassword: this.approvePasswordCtrl,
    });
  }

  onClose() {
    this.notify.emit({type: 'close'});
  }

  onSubmit() {
    this.submitting = true;
    if (this.form.valid && !this.submitPressed) {
      this.submitPressed = true;
      if (this.newPasswordCtrl.value === this.approvePasswordCtrl.value) {
        this.submitting = true;
        const data: any = {
          old_password: this.oldPasswordCtrl.value,
          password: this.newPasswordCtrl.value,
        };
        this.usersService.changePassword(data).subscribe((res) => {
          this.notify.emit({type: 'close'});
          this.submitting = false;
          this.toast.showToast({title: 'Пароль успешно изменён'});
        }, (err) => {
          this.submitting = false;
          this.submitPressed = false;
          if (err && err.error.code === 'old_password') {
            this.oldPasswordCtrl.setValue(null);
            this.oldPassword = err.error.message;
          } else {
            const defaultMessage = 'Что-то пошло не так. Пожалуйста, попробуйте еще раз или обратитесь к системному администратору.';
            this.errorMessage = err && err.error && err.error.message ? err.error.message : defaultMessage;
            this.toast.showToastFromError(defaultMessage);
          }
        });
      } else {
        this.approvePasswordCtrl.setValue(null);
      }
    } else {
      this.submitPressed = false;
    }
  }
}
